
<div class="trinka_cloud_wrap">
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <h1>API de Verificação Gramatical</h1>
                        <h2>API de Verificação Gramatical Simples e Rápida Baseada em Inteligência Artificial</h2>
                        <p>A verificação gramatical do Trinka, baseada em inteligência artificial, é fornecida através de uma API RESTful simples, para permitir verificações gramaticais poderosas, passivas ou em tempo real, diretamente de dentro do seu aplicativo.</p>
                        <button type="button" data-toggle="modal" data-target="#EnterPriseContactPopup" class="plansButtons">Contato</button>
                        <a href="#sampleCode"  data-toggle="modal" data-target="#sampleCode" id="autoEditGetStart" class="cta-outline-btn m25">Amostra de Código</a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_img text-center" style="text-align: center !important;">
                        <img src="../../../assets/images/trinka-api.svg" alt="Grammar Check API">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="most_suited_for_section mt-40">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="most_united_heading">
                    <h2>
                        <span></span>Integrações Únicas para Alimentar Aplicações sob Medida</h2>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="most_suited_point">
                    <ul>
                        <li>Sistemas de Gerenciamento de Conteúdo</li>
                        <li>Plataformas de Escrita On-Line</li>
                        <li>Aplicativos de Mensagens/Redes Sociais</li>
                        <li>Software de CRM e Help Desk</li>
                        <li>Clientes de E-mail</li>
                        <li>Software de Gerenciamento de Projetos</li>
                        <li>Plataformas de Aprendizado Eletrônico</li>
                        <li>Sistemas de Gerenciamento de Aprendizado</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="cloud_key_features cloudKeyBenefitSection mb-0 bg-white">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="key_features_heading mb-0">
                    <h2>Texto ou Arquivos - Com as APIs do Trinka, Você Escolhe</h2>
                    <div class="HeadingSubLine"></div>
                    <p class="mb-0">Faça integrações transparentes com as APIs de verificação gramatical do Trinka para satisfazer seu fluxo de trabalho e suas necessidades técnicas.</p>
                </div>
            </div>
        </div>
    </div>
    <div class="writeToolbox_inner_sections">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <div class="wrapper_left">
                        <h3>API de Verificação em Tempo Real</h3>
                        <p>As verificações em tempo real do Trinka alimentam aplicativos que precisam de correções instantâneas de escrita em plataformas de aprendizado, editores, aplicativos de chat e semelhantes.</p>
                        <ul>
                            <li>Flexibilidade para passar linhas, parágrafos ou conjuntos maiores de texto</li>
                            <li>Parâmetros de resposta simples para todos os formatos de entrada</li>
                            <li>Flexibilidade de pagar por volume de texto ou por chamada à API</li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="wrapper_right">
                        <img src="../../../assets/images/Real-time Check API.svg" alt="Real-time Check API" class="img-fluid" />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolbox_inner_sections" style="padding-top: 0;">
        <div class="container">       
            <div class="row flex-row-reverse align-items-center">
                <div class="col-lg-6 col-md-6">
                    <div class="wrapper_left">
                        <h3>API de edição de arquivos</h3>
                        <p>A API de edição de arquivos do Trinka permite que você dê suporte a necessidades únicas do seu fluxo de trabalho, ao mesmo tempo que evita integrações cokmplexas e um alto volume de chamadas à API. </p>
                        <ul>
                            <li>Tenha arquivos editados com uma única chamada à API</li>
                            <li>Marcação de alterações para controle de versões e de usuários</li>
                            <li>Pontuações de qualidade de escrita e resumos de revisão para avaliações</li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6">
                    <div class="wrapper_right">
                        <img src="../../../assets/images/file-edit-api.png" alt="File-edit API" class="img-fluid" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="cloud_key_features cloudKeyBenefitSection mb-0 bg-light-purple">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="key_features_heading">
                    <h2>Casos Únicos de Uso da API de Verificação Gramatical do Trinka</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row match-box">

            <div class="col-lg-4 col-md-6 dflex">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>Aplicativos de Aprendizado Eletrônico</h3>
                    </div>
                    <p>A API de verificação gramatical do Trinka tem ajudado desenvolvedores de aplicativos a refinar a escrita dos seus alunos para satisfazer a padrões acadêmicos.</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 dflex">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>Publicação e Editoras</h3>
                    </div>
                    <p>A API de verificação gramatical do Trinka ajuda o pessoal de editoras com correção assistida de texto, poupando tempo e custos com maior qualidade.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 dflex">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>Fóruns de Estudantes</h3>
                    </div>
                    <p>As verificações robustas da API de verificação gramatical do Trinka faz com que estudantes se comuniquem de forma eficaz em fóruns e grupos, melhorando seu engajamento.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 dflex">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>Empresas</h3>
                    </div>
                    <p>A API de verificação gramatical do Trinka tem dado a várias equipes o poder de escrever melhor sem sacrificar a clareza, a consistência ou a percepção da marca.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 dflex">
                <div class="features_cards">
                    <div class="features_cardsHeading">
                        <h3>Plataformas de Produtividade</h3>
                    </div>
                    <p>A API em tempo real do Trinka permite que plataformas de produtividade ofereçam assistência exclusiva à escrita, para ajudar seus usuários a serem mais produtivos.</p>
                </div>
            </div>

        </div>
        
    </div>
</div>

<div class="use_trinka_other_app accomplishBrilliantWrap mt-0">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="accomplishBrilliantSection">
                    <h2>Veja o Que a API de Verificação Gramatical do Trinka Pode Fazer por Você</h2>
                    <a data-toggle="modal" data-target="#EnterPriseContactPopup" class="plansButtons pointer">Contato</a>
                </div>
            </div>
        </div>
            
    </div>
</div>

<div class="cloud_key_features cloudKeyBenefitSection cs-section">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="key_features_heading mb-3">
                    <h2>Acesso a Todos os Recursos do Trinka com uma API Simples</h2>
                    <div class="HeadingSubLine"></div>
                    
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-5 col-xl-5">
                <div class="cs-left-section">
                    <p>A API de verificação gramatical do Trinka oferece uma assistência abrangente à escrita, que vai desde correções avançadas da gramática inglesa até aperfeiçoamentos no tom e no estilo. Escolha os recursos que atendem às suas necessidades!</p>

                    <p>A API de verificação gramatical e ortográfica do Trinka refina a maneira como você escreve, para satisfazer as convenções e seguir as melhores práticas de escrita acadêmica, enquanto deixa você se concentrar mais nas suas ideias.</p>

                    <p>API de verificação gramatical do Trinka também oferece outros recursos, tais como fraseado técnico, tom acadêmico, linguagem sem preconceito, escolha de palavras, uso do idioma e estilo e outros.</p>
                </div>
            </div>
            <div class="col-lg-7 col-xl-7">
                <div class="xs-features-api">
                    <span class="hline"></span>
                    <span class="vline"></span>
                    <span class="vline vline2"></span>
                    <div class="row match-box">
                        <div class="col-md-6 col-sm-6 col-12 dflex">
                            <div class="features_cards media">
                                <div class="icon media-left">
                                    <img src="../../../../assets/images/icons/Advanced-Grammar.png" alt="Advanced Grammar" />
                                </div>
                                <div class="media-body">
                                    <div class="features_cardsHeading ">
                                        <h3>Gramática Avançada</h3>
                                    </div>
                                    <p>O melhor para a comunicação acadêmica e formal
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-12 dflex">
                            <div class="features_cards media">
                                <div class="icon media-left">
                                    <img src="../../../../assets/images/icons/Icon_ExpertProofreading.png" alt="Subject-specific Corrections" />
                                </div>
                                <div class="media-body">
                                    <div class="features_cardsHeading">
                                        <h3>Correções Específicas por Assunto</h3>
                                    </div>
                                    <p>Detecção automática de assunto e sugestões precisas
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-12 dflex">
                            <div class="features_cards media">
                                <div class="icon media-left">
                                    <img src="../../../../assets/images/icons/Icon_title.png" alt="Contextual Spelling" />
                                </div>
                                <div class="media-body">
                                    <div class="features_cardsHeading">
                                        <h3>Ortografia Contextual</h3>
                                    </div>
                                    <p>Escolhe os termos corretos com base no seu assunto
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-12 dflex">
                            <div class="features_cards media">
                                <div class="icon media-left">
                                    <img src="../../../../assets/images/icons/Icon_Pass_02.png" alt="Tips & Explanations" />
                                </div>
                                <div class="media-body">
                                    <div class="features_cardsHeading">
                                        <h3>Dicas e Explicações</h3>
                                    </div>
                                    <p>Sugestões da inteligência artificial explicáveis aos usuários
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-12 dflex">
                            <div class="features_cards media">
                                <div class="icon media-left">
                                    <img src="../../../../assets/images/icons/Non-standard-2.png" alt="Style Guide Preference" />
                                </div>
                                <div class="media-body">
                                    <div class="features_cardsHeading">
                                        <h3>Preferência de Guia de Estilo</h3>
                                    </div>
                                    <p>Sugere correções baseadas em guias de estilo (AMA, APA, etc.)
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-12 dflex">
                            <div class="features_cards media no-border-before">
                                <div class="icon media-left">
                                    <img src="../../../../assets/images/icons/Icon_Dictionary.png" alt="Custom Dictionaries" />
                                </div>
                                <div class="media-body">
                                    <div class="features_cardsHeading">
                                        <h3>Dicionários Personalizados</h3>
                                    </div>
                                    <p>Melhore as sugestões e mantenha sua consistência
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="pricing_works">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-8">
                <div class="brandlogo_heading">
                    <h2>Preços Flexíveis que Se Adequam Melhor a Você</h2>
                </div>
                <p>Trabalhamos com você para identificar o melhor modelo de preços, que lhe dê o melhor custo/benefício. Temos suporte a opções de preço baseadas no volume de texto, de arquivos ou de chamadas à API, para satisfazermos às suas exatas necessidades.</p>
            </div>

            <div class="col-lg-12">
                <div class="try_trinka_Buttons">

                    <button data-toggle="modal"
                        data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">Peça um Orçamento</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="writeToolboxs_section1">
    <div class="writeToolbox_inner_sections1">
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>Seguro e confiável</h3>
                        <p>Trinka coloca a segurança e a privacidade dos dados em primeiro plano. Todos os seus dados são fortemente
                            criptografados e armazenados com segurança - ninguém mais tem acesso aos seus dados. Oferecemos
                            planos exclusivos que eliminam completamente o salvamento de qualquer dado assim que você receber
                            sugestões de redação.
                        </p>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="../../../assets/images/safe-secure.png" alt="safe secure" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolbox_inner_sections1 sections_height_set publicationCheckSections" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');">
        <div class="container">
            <div class="row">
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="../../../assets/images/about-ai.png" alt="about ai" class="img-fluid">
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>Sobre a AI</h3>
                        <p>Trinka usa as mais recentes técnicas de aprendizado de máquina (ML) e processamento de linguagem
                            natural (PNL) para identificar erros gramaticais e sugerir aprimoramentos de linguagem. Ele é
                            treinado em milhões de documentos e artigos bem escritos que abrangem mais de 1300 áreas, incluindo
                            medicina, ciências biológicas, biologia , ciências físicas, engenharia, humanas, negócios e artes
                            para dar a você as sugestões mais relevantes.</p>
                        <p>Trinka é desenvolvido por uma equipe de lingüistas, editores médicos, cientistas de dados e engenheiros
                            com um profundo desejo de criar um futuro com comunicação sem barreiras.
                        </p>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="pricingQuestionAnwser" #target>
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="pricingHeadingQuestion">
                    <h2>Perguntas Frequentes</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <div class="pricingQuestionsList">
                    <div class="accordion" id="faq">
                        <div class="card">
                            <div class="card-header" id="QuestionOne">
                                <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                    A quem se destina uma API de verificação gramatical ou ortográfica?</a>
                            </div>

                            <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                <div class="card-body">
                                    <p>Nossas APIs de verificação gramatical podem ser usadas para muitas finalidades diferentes. Aqui estão algumas das coisas para as quais nossos clientes atuais usam nossas APIs:</p>
                                    <ol>
                                        <li>Marcação automática de ensaios</li>
                                        <li>Adicionar a verificação gramatical a editores de texto em aplicativos.</li>
                                        <li>Melhorar a qualidade de serviços de revisão.</li>
                                        <li>Verificar Web sites quanto a problemas de gramática.</li>
                                        <li>Dar feedback a estudantes de inglês.</li>
                                        <li>Verificar traduções quanto a erros gramaticais.</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="QuestionTwo">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                    aria-controls="QuestionTwoContent">
                                    Posso integrar a verificação em tempo real ao meu editor de textos?</a>
                            </div>

                            <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                <div class="card-body">
                                    <p>Integrar a verificação em tempo real a um editor de textos é um caso comum de utilização. A verificação gramatical tornou-se um recurso esperado sempre que alguém escreve. Tornamos fácil integrá-la a qualquer editor on-line. Desenvolvemos um componente de verificação gramatical que tornou isso fácil. Você deverá conseguir integrar a verificação gramatical e ortográfica ao seu editor em alguns minutos. Também é fácil personalizar a aparência do componente para coincidir com o estilo visual da sua empresa. Você pode até adicionar atalhos de teclado e fazer outras personalizações.</p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="QuestionFour">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                    aria-controls="QuestionFourContent">
                                    Existe um teste gratuito? 
                                </a>
                            </div>

                            <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                <div class="card-body">
                                    <p>Sim, você pode experimentar nossa API gratuitamente. Basta <a data-toggle="modal" data-target="#EnterPriseContactPopup">entrar em contato conosco!</a></p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="QuestionFive">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                    aria-controls="QuestionFourContent">
                                    A documentação da API está disponível?
                                </a>
                            </div>

                            <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                <div class="card-body">
                                    <p>Sim! Fornecemos uma documentação detalhada e suporte à integração, para ajudar você a integrar a API do Trinka. Basta <a data-toggle="modal" data-target="#EnterPriseContactPopup">entrar em contato conosco!</a></p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="QuestionSix">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSixContent" aria-expanded="true"
                                    aria-controls="QuestionFourContent">
                                    Há algum custo adicional para começar a trabalhar com a API de verificação gramatical?
                                </a>
                            </div>

                            <div id="QuestionSixContent" class="collapse" aria-labelledby="QuestionSix" data-parent="#faq">
                                <div class="card-body">
                                    <p>Não, não há nenhum tipo de taxa de instalação. <a data-toggle="modal" data-target="#EnterPriseContactPopup">Comece já.</a></p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-lg-1"></div>
        </div>
    </div>
</div>

<div class="modal custom_modal_popup enterprisePopup sampleCode" id="sampleCode">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-body">
                <div class="code-block">
                    <div class="closed_icons">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="row no-margin">
                        <div class="col-sm-6 no-gutter">
                            <h3 class="code-title">Amostra de Código:</h3>
                            <div class="code-bloc">
                            <pre class="html ">
                                <div class="style-4 code">
1 curl --location --request POST
2 <span class="tx-green">'https://check.trinka.ai/languagecheck/v1/check' \</span>
3 --header 'x-api-key: xxxxzxzxzxzxzxzxzxzxz \
4 --header 'Content-Type: application/json' \
5
6 --data-raw '<span class="tx-yellow">&#123;</span>
7 <span class="tx-l-blue">"paragraph"</span>: <span class="tx-orange">"Wood is a natural material used in indoor environment.         
<span class="tx-white">8</span>    It is utilized as not only a structural component 
<span class="tx-white">9</span>    but also an interior finishing material that can be directly 
<span class="tx-white">10</span>    seen and touched in different buildings, such as houses, 
<span class="tx-white">11</span>    offices, and public facilities. Moreover, it brings a 
<span class="tx-white">12</span>    positive impression, such as comfort and relaxation, 
<span class="tx-white">13</span>    among residents and users."</span>,
14 <span class="tx-l-blue">"language"</span>: <span class="tx-orange">"US"</span>
15 <span class="tx-yellow">&#125;</span>'
                                </div>
                            </pre>
                            </div>
                        </div>
                        <div class="col-sm-6 no-gutter">
                            <h3 class="code-title">Amostra de Resposta:</h3>
                            <div class="code-bloc">
                            <pre class="html style-4">
                                <div class="style-4 code ">
1 <span class="tx-yellow">&#123;</span>
2    <span class="tx-l-blue">"status"</span>: <span class="tx-d-blue">true</span>,
3   <span class="tx-l-blue">"input_para"</span>: <span class="tx-orange">"Wood is a natural material used in indoor environment. It is utilized as not only a structural component but also an interior finishing material that can be directly seen and touched in different buildings, such as houses, offices, and public facilities. Moreover, it brings a positive impression, such as comfort and relaxation, among residents and users."</span>,
4    <span class="tx-l-blue">"sentences"</span>: <span class="tx-pink">&#91;</span>
5        <span class="tx-d-blue">&#123;</span>
6            <span class="tx-green">/*** Input sentence and the offsets for the sentence ***/</span>
7            <span class="tx-l-blue">"sentence"</span>: <span class="tx-orange">"Wood is a natural material used in indoor environment."</span>,
8           <span class="tx-l-blue">"begin"</span> <span class="tx-l-green">0</span>,
9            <span class="tx-l-blue">"end"</span>: <span class="tx-l-green">54</span>,
10            <span class="tx-l-blue">"result"</span>: <span class="tx-yellow">&#91;</span>
11                <span class="tx-pink">&#123;</span>
12                   <span class="tx-green">/*** Detected issue and its details ***/</span>
13                    <span class="tx-l-blue">"start_index"</span>: <span class="tx-l-green">35</span>,
14                    <span class="tx-l-blue">"end_index"</span>: <span class="tx-l-green">40</span>,
15                    <span class="tx-l-blue">"covered_text"</span>: <span class="tx-orange">"indoor"</span>,
16                    <span class="tx-l-blue">"output"</span>: <span class="tx-d-blue">&#91;</span>
17                        <span class="tx-orange">"the indoor"</span>
18                    <span class="tx-d-blue">&#93;</span>,
19                    <span class="tx-green">/***  Suggestion for replacement or a comment ***/</span>
20                    <span class="tx-l-blue">"comment"</span>: <span class="tx-d-blue">&#91;</span>
21                        <span class="tx-orange">"Insert 'a', 'an', or 'the' before 'indoor'."</span>
22                    <span class="tx-d-blue">&#93;</span>,
23                    <span class="tx-green">/*** Error categorization ***/</span>
24                    <span class="tx-l-blue">"error_category"</span>: <span class="tx-d-blue">&#91;</span>
25                        <span class="tx-orange">"Grammar-Article"</span>
26                    <span class="tx-d-blue">&#93;</span>,
27                    <span class="tx-green">/*** Replacement text for the detected error ***/</span>
28                    <span class="tx-l-blue">"output"</span>: <span class="tx-d-blue">&#91;</span>
29                        <span class="tx-d-blue">true</span>
30                    <span class="tx-d-blue">&#93;</span>,
31                <span class="tx-pink">&#125;</span>
32            <span class="tx-yellow">&#93;</span>
33        <span class="tx-d-blue">&#125;</span>,
34        <span class="tx-d-blue">&#123;</span>
35            <span class="tx-green">/*** Input sentence and the offsets for the sentence ***/</span>
36            <span class="tx-l-blue">"sentence"</span>: <span class="tx-orange">"It is utilized as not only a structural component but also an interior finishing material that can be directly seen and touched in different buildings, such as houses, offices, and public facilities."</span>,
37            <span class="tx-l-blue">"begin"</span> <span class="tx-l-green">55</span>,
38            <span class="tx-l-blue">"end"</span>: <span class="tx-l-green">254</span>,
39            <span class="tx-l-blue">"result"</span>: <span class="tx-yellow">&#91;</span>
40                <span class="tx-pink">&#123;</span>
41                    <span class="tx-green">/*** Detected issue and its details ***/</span>
42                    <span class="tx-l-blue">"start_index"</span>: <span class="tx-l-green">6</span>,
43                    <span class="tx-l-blue">"end_index"</span>: <span class="tx-l-green">13</span>,
44                    <span class="tx-l-blue">"covered_text"</span>: <span class="tx-orange">"utilized"</span>,
45                    <span class="tx-l-blue">"output"</span>: <span class="tx-d-blue">&#91;</span>
46                        <span class="tx-orange">"used"</span>
47                    <span class="tx-d-blue">&#93;</span>,
48                    <span class="tx-green">/***  Suggestion for replacement or a comment ***/</span>
49                    <span class="tx-l-blue">"comment"</span>: <span class="tx-d-blue">&#91;</span>
50                        <span class="tx-orange">"Plain language tip: Replace \"utilized\" with \"used\" if it fits the context."</span>
51                    <span class="tx-d-blue">&#93;</span>,
52                    <span class="tx-green">/*** Error categorization ***/</span>
53                    <span class="tx-l-blue">"error_category"</span>: <span class="tx-d-blue">&#91;</span>
54                        <span class="tx-orange">"Enhancement"</span>
55                    <span class="tx-d-blue">&#93;</span>,
56                    <span class="tx-green">/*** Replacement text for the detected error ***/</span>
57                    <span class="tx-l-blue">"output"</span>: <span class="tx-d-blue">&#91;</span>
58                        <span class="tx-d-blue">true</span>
59                    <span class="tx-d-blue">&#93;</span>,
60                <span class="tx-pink">&#125;</span>
61            <span class="tx-yellow">&#93;</span>
62        <span class="tx-d-blue">&#125;</span>,
63    <span class="tx-pink">&#93;</span>,
64    <span class="tx-l-blue">"message"</span>: <span class="tx-orange">"Success"</span>
65 <span class="tx-yellow">&#125;</span> 
                                </div>
                            </pre>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<app-enterprise-modal></app-enterprise-modal>